/* PORTED VERBATIM from mondain-html/assets/momsticker.js (parity phase 3,
   2026-08-29) for the object PDPs (sections/mondain-product-rack.liquid).
   mondain-rack.js is the same file under the rack deck's name; the two stay
   in lockstep with the gold. */
/* =========================================================================
   THE MOM STICKER's living light (2026-08-27): each plate's specular band
   sits at a position derived from where the plate is in the viewport, so
   scrolling slides the light across the metal. Shared by rack.html and
   the nine object PDPs.
   ========================================================================= */

(function () {
  'use strict';

  function boot() {
    var plates = [].slice.call(document.querySelectorAll('.mdn-momsticker'));
    if (!plates.length) return;
    /* WATERFALL (2026-08-27, Seamas: staggered, not three symmetrical
       shimmers): each plate carries a lag proportional to its order, so
       the light arrives down the grid one plate after another; the same
       index staggers the glint twinkle. */
    plates.forEach(function (plate, i) {
      plate.style.setProperty('--mdn-glint-delay', (i * 0.7) + 's');
    });
    var ticking = false;
    function paint() {
      ticking = false;
      for (var i = 0; i < plates.length; i++) {
        var r = plates[i].getBoundingClientRect();
        if (r.bottom < -80 || r.top > innerHeight + 80) continue;
        var t = (r.top + r.height / 2) / innerHeight - i * 0.085;
        plates[i].style.setProperty('--mdn-sheen', (t * 220 - 60) + '%');
      }
    }
    addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
